import { Circle, CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";
import type { TFunction } from "i18next";
import { accentText } from "../styles";

export function PasswordChecklist({
  t,
  passedChecks,
  passwordChecks,
}: {
  t: TFunction;
  passedChecks: number;
  passwordChecks: { key: string; label: string; valid: boolean }[];
}) {
  return (
    <div className="rounded-xl border border-[var(--color-border)]/60 bg-gradient-to-br from-[var(--color-grey)]/80 to-[var(--color-white)] p-4 dark:border-[var(--color-dark_border)]/60 dark:from-[var(--color-slateGray)]/40 dark:to-[var(--color-deepSlate)]/40">
      <div className="mb-3 flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-wider text-[var(--color-charcoalGray)] dark:text-[var(--color-muted)]">
          {t("passwordChecklist")}
        </span>
        <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-bold ${accentText} bg-[var(--color-tealGreen)]/10 dark:bg-[var(--color-primary)]/15`}>
          {passedChecks}/4
        </span>
      </div>
      <div className="mb-4 h-1.5 w-full overflow-hidden rounded-full bg-[var(--color-muted)]/50 dark:bg-[var(--color-dark_border)]/40">
        <motion.div
          className="h-full rounded-full bg-gradient-to-r from-[var(--color-tealGreen)] to-[var(--color-secondary)] dark:from-[var(--color-primary)] dark:to-[var(--color-tealGreen)]"
          animate={{ width: `${(passedChecks / 4) * 100}%` }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        />
      </div>
      <div className="space-y-2">
        {passwordChecks.map((item) => (
          <motion.div
            key={item.key}
            initial={false}
            animate={{ x: item.valid ? [0, 2, 0] : 0 }}
            transition={{ duration: 0.3 }}
            className="flex items-center gap-2.5 text-xs"
          >
            <div className={`flex h-5 w-5 items-center justify-center rounded-full transition-all duration-200 ${item.valid ? "bg-[var(--color-success)]/15 dark:bg-[var(--color-success)]/20" : "bg-[var(--color-muted)]/30 dark:bg-[var(--color-dark_border)]/30"}`}>
              {item.valid ? (
                <CheckCircle2 size={12} className="text-[var(--color-success)]" strokeWidth={2.5} />
              ) : (
                <Circle size={12} className="text-[var(--color-charcoalGray)]/50 dark:text-[var(--color-muted)]/50" />
              )}
            </div>
            <span
              className={`transition-all duration-200 ${
                item.valid
                  ? "font-medium text-[var(--color-midnight_text)] dark:text-[var(--color-white)]"
                  : "text-[var(--color-charcoalGray)] dark:text-[var(--color-muted)]"
              }`}
            >
              {item.label}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
